"use strict";require("react");var e=require("react/jsx-runtime");exports.default=()=>e.jsx(e.Fragment,{});